import React, { useState, useEffect } from 'react'
import BannerBg from '../assets/banner-bg.jpg';
import '../css/components/Dashboard.css';
import ResponseMsg from '../general/ResponseMsg';
import Cart from '../components/Cart.js';
import { useNavigate } from 'react-router-dom';
import Loading from '../general/Loading';
import { Link } from 'react-router-dom';
import Whatsapp from '../assets/whatsapp.webp';
import Call from '../assets/call.png';
import Default from '../assets/default.jpg';


const Dashboard = ({ userData }) => {
        const [response, setResponse] = useState(null);
    const [item, setItem] = useState([]);
    const [offers, setOffers] = useState([]);
    const [offerImgUrls, setOfferImgUrls] = useState([]);
    const [cart, setCart] = useState([]);
    // const [showCart, setShowCart] = useState(false);
const [searchInput, setSearchInput] = useState('');
const [searchQuery, setSearchQuery] = useState('');
    const navigate = useNavigate();
      const [loading, setLoading] = useState(false);
      const message = `Hey KCM Distributors!%0AI want to know about your Products.`;
      const [visibleProducts, setVisibleProducts] = useState([]);
      const [batchIndex, setBatchIndex] = useState(0);


    useEffect(() => {
        const savedCart = JSON.parse(localStorage.getItem('cart'));

        if (savedCart && Array.isArray(savedCart)) {
            setCart(savedCart);
        } else {
            setCart([]);
        }
    }, []);

    useEffect(() => {
        const fetchOffers = async () => {
            try {
                const response = await fetch('https://api.kcmstore.in/dist/get-offers');
                if (response.ok) {
                    const data = await response.json();
                    setOffers(data);
                    const imgUrls = data.map(offer => {
                        return `https://api.kcmstore.in/uploads/${offer.image}`;
                    });
                    setOfferImgUrls(imgUrls);
                } else {
                    console.error('Failed to fetch offers');
                }
            } catch (error) {
                console.error('Error fetching offers:', error);
            }
        };

        fetchOffers();
    }, []);


    useEffect(() => {
        const fetchProducts = async () => {
            setLoading(true);
            try {
                const response = await fetch('https://api.kcmstore.in/dist/get-product');

                if (response.ok) {
                    const data = await response.json();
                    // const formattedData = data.map(item => ({
                    //     ...item,
                    //     mfg: item.mfg ? item.mfg.split(' ')[0] : '',
                    //     exp: item.exp ? item.exp.split(' ')[0] : ''
                    // }));
                    setItem(data);
                    setVisibleProducts(data.slice(0, 100));
                    setBatchIndex(1);
                    setLoading(false);
                } else {
                    setLoading(false);
                    console.error('Failed to fetch users');
                }
            } catch (error) {
                setLoading(false);
                console.error('Error fetching data:', error);
            }
        };

        fetchProducts();
    }, []);


    useEffect(() => {
        if (batchIndex === 0 || item.length === 0) return;
    
        const interval = setInterval(() => {
          setVisibleProducts((prev) => [
            ...prev,
            ...item.slice(batchIndex * 100, (batchIndex + 1) * 100),
          ]);
          setBatchIndex((prev) => prev + 1);
        }, 1500);
    
        return () => clearInterval(interval);
      }, [batchIndex, item]);
    

    const handleAddCart = (items) => {
        if(userData.address == ''){
            setResponse('Update Address Details in your profile.');
            setTimeout(() => {
                setResponse('');
            }, 2000);
            return;
          }
          
        if (!items) {
            console.error('Invalid product data');
            setTimeout(() => {
                setResponse('');
            }, 2000);
            return;
        }

        if (items.stock == 'Stock Out') {
            setResponse('This product is currently out of stock.');
            setTimeout(() => {
                setResponse('');
            }, 2000);
            return;
        }

        setLoading(true);

        const existingCart = JSON.parse(localStorage.getItem('cart')) || [];
        if (!Array.isArray(existingCart)) {
            console.error('Error: existingCart is not an array');
            return;
        }

        const productIndex = existingCart.findIndex(item => item.id === items.id);

        if (productIndex === -1) {
            existingCart.push({ ...items, quantity: 1 });
        } else {
            existingCart[productIndex].quantity += 1;
        }

        localStorage.setItem('cart', JSON.stringify(existingCart));
        setCart(existingCart);
        setResponse('Product added to cart.');
        setLoading(false);
        setTimeout(() => {
            setResponse('');
        }, 2000);
    };


const getFilteredItems = (products, query) => {
  if (!query) return products;

  const words = query.toLowerCase().split(' ');
  let match = '';

  for (let i = 0; i < words.length; i++) {
    const tryMatch = words.slice(0, words.length - i).join(' ');
    const results = products.filter(item =>
      item.name.toLowerCase().includes(tryMatch)
    );

    if (results.length > 0) {
      return results;
    }
  }

  return []; // no matches at all
};

const filteredItems = getFilteredItems(visibleProducts, searchQuery);

    

      const handleQuantityChange = (productId, action) => {
        const updatedCart = cart.map(item => {
            if (item.id === productId) {
                let newQuantity = action === 'increment' ? item.quantity + 1 : item.quantity - 1;
    
                if (newQuantity < 1) {
                    setResponse('Product removed from cart.');
                    setTimeout(() => {
                        setResponse('');
                    }, 2000);            
                    return null;
                }
    
                return { ...item, quantity: newQuantity };
            }
            return item;
        }).filter(item => item !== null);
    
        setCart(updatedCart);
        localStorage.setItem('cart', JSON.stringify(updatedCart));
    };
    
    const getGreeting = () => {
        const currentHour = new Date().getHours();
      
        if (currentHour < 12) return 'Hey! Good Morning 🌻';
        else if (currentHour < 16) return 'Good Afternoon 🌞! Had Lunch?';
        else if (currentHour < 20) return 'Good Evening ⭐';
        else return 'Good Night 😴';
      };

    return (
        <>
            <section className='px-md-3 px-sm-3 py-3'>
                <div className='profile-area-inner px-lg-5 py-lg-5 px-3 py-3 animate__animated animate__fadeInUp'>
                    <p className='profile-heading'>KCM Pharma <br /><span className='float-md-end greeting-text'>{getGreeting()}</span></p>

                    <div id="carouselExampleIndicators" className="carousel slide pt-md-3" data-bs-ride="carousel" data-bs-interval="2000">
    <div className="carousel-indicators">
        {offers.length > 0 &&
            offers.map((offer, index) => (
                <button
                    key={index}
                    type="button"
                    data-bs-target="#carouselExampleIndicators"
                    data-bs-slide-to={index}
                    className={index === 0 ? 'active' : ''}
                    aria-label={`Slide ${index + 1}`}
                ></button>
            ))
        }
    </div>

    <div className="carousel-inner">
        {offers.length > 0 ? (
            offers.map((offer, index) => {
                const offerUrl = `https://api.kcmstore.in/uploads/${offer['image']}`;
                return (
                  <>
                    <div
                        key={index}
                        className={`carousel-item align-content-center ${index === 0 ? 'active' : ''} banner-bg`}
                        style={{ backgroundImage: `url(${offerUrl || BannerBg})` }}
                    >
                        <div className="container py-5">
                            <p className="fs-5 fw-semibold">{offer.offer_tagline}</p>
                            <p className="banner-heading col-lg-6 col-md-8">{offer.offer_name}</p>
                            <p className="col-lg-5 col-md-8 fw-semibold">{offer.description}</p>
                        </div>
                    </div>
                    </>
                );
            })
        ) : (
            <div className="carousel-item active align-content-center banner-bg" style={{ backgroundImage: `url(${BannerBg})` }}>
                <div className="container py-5">
                    <p className="fs-5 fw-semibold">Get Medicines at your Doorstep</p>
                    <p className="banner-heading col-lg-6 col-md-8">KCM - Your Online Medical Buddy</p>
                    <p className="col-lg-5 col-md-8 fw-semibold">
                        We deliver a wide range of medicines directly to your doorstep, ensuring convenience and reliability. Your health is our top priority!
                    </p>
                </div>
            </div>
        )}
    </div>
</div>


<div className="text-start my-4 d-flex gap-2">
  <input
    type="text"
    className="profile-input rounded border-0 bg-light flex-grow-1"
    placeholder="🎯 Search products..."
    value={searchInput}
    onChange={(e) => setSearchInput(e.target.value)}
  />
  <button className="login-btn px-3" onClick={async () => {
      setLoading(true);
      setSearchQuery(searchInput);

      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }}>
    <i class="fa-solid fa-magnifying-glass"></i>
  </button>
</div>

{/* // {searchQuery && (
//   <span
//     className="fw-semibold cursor-pointer"
// onClick={() => {
//     window.location.reload();
//   setLoading(true);
//   setSearchInput('');
//   setSearchQuery('');

//   const timeoutId = setTimeout(() => {
//     setLoading(false);
//   },200);
//   return () => clearTimeout(timeoutId);
// }}
//   >
//     Clear Search <i className="fa-solid fa-circle-xmark"></i>
//   </span>
// )} */}
                    <div className='row mt-2'>

                        {filteredItems.length > 0 ? (
                            filteredItems.map((items) => {
                                const existingCart = JSON.parse(localStorage.getItem('cart')) || [];
                                const productIndex = existingCart.findIndex(item => item.id === items.id);
                                const isInCart = productIndex !== -1;
                                return (
                                <div className='col-lg-3 col-md-6 col-6 my-2'>
                                    <div className={`h-100 align-content-center ${isInCart ? 'product-area-active' : 'product-area'}`}>

                                        <p className={`product-icon ${items.stock  == 'In Stock' ? 'text-success' : 'text-danger'}`}>
                                            {items.stock}
                                            {/* <Link to='tel:9438244971'><img src={Call} className='img-fluid' alt='Whatsapp icon' /></Link><br />
                                            <Link to={`https://wa.me/+919438244971?text=${message}`} target='_blank' className='text-success'>
                                            <img src={Whatsapp} className='img-fluid' alt='Whatsapp icon' /></Link> */}
                                        </p>

                                        <div className='text-center'>
                                        <img 
  src={items.image ? `https://api.kcmstore.in/uploads/${items.image.split(',')[0]}` : Default} 
  className='product-img' 
  alt={items.name} 
/>
                                        </div>
 {items.stock == 'In Stock' && <span className='product-icon2'>Live Stock: {items.stock_qty}</span>}
                                                        
                                        <p className='product-name my-0 cursor-pointer' onClick={() => navigate(`/product-details/${items.name}`, { state: { items } })}>{items.name}<br />
                                            <span className='product-info'>Pack of {items.unit}</span></p>
                                        <p><span className='product-price'>₹{items.sell_price}</span>&nbsp;
                                        <span className='product-discount text-decoration-line-through'>₹{items.org_price}</span>
                                            {/* {items.discount_type == 'amount' ? '₹' : ''}{items.discount_amount != 0 ? `${items.discount_amount}Off` : ''}{items.discount_type == 'percent' ? '%Off' : ''}</span> */}
                                            </p>
                                        {/* <button className='add-btn' onClick={() => handleAddCart(items)}>Add Cart <i class="fa-solid fa-cart-shopping"></i></button> */}

                                        {isInCart ?
                                                <p className='my-0'>
                                                <span className='action-btn' onClick={() => handleQuantityChange(items.id, 'decrement')}>-</span>
                                                <span className='px-2 fw-semibold'>
  {existingCart.map(item => 
    item.id === items.id ? item.quantity : null
  )}
</span>
                                                <span className='action-btn' onClick={() => handleQuantityChange(items.id, 'increment')}>+</span></p>
                                                    : <button
                                                            className='add-btn'
                                                            onClick={() => handleAddCart(items)}
                                                            disabled={items.stock === '0'}
                                                        >+ Cart</button>}

                                    </div>
                                </div>
                                )
                            })
                        ) : (
                            <p>No Products added yet.</p>
                        )}

                    </div>
                    {/* row ends */}

                </div>
            </section>

<div className='enquiry-area'>
            <Link to='tel:7854060567'><img src={Call} className='img-fluid' alt='Whatsapp icon' /></Link><br />
                                            <Link to={`https://wa.me/+917854060567?text=${message}`} target='_blank' className='text-success'>
                                            <img src={Whatsapp} className='img-fluid' alt='Whatsapp icon' /></Link></div>

<div className='cart-btn-area'>
    <span className='cart-num'>{cart.length}</span>
            <button className='cart-btn' onClick={() => navigate('/cart')}><i class="fa-solid fa-shopping-cart"></i></button></div>

            {loading && <Loading setLoading={setLoading} />}

            {response && <ResponseMsg message={response} />}

            {/* {showCart && <Cart setShowCart={setShowCart} userData={userData} />} */}
        </>
    )
}

export default Dashboard
